import { Label, TextOrHTML } from "@simplybusiness/mobius";
import type { QuestionLabelProps } from "./QuestionFactory";

export const QuestionLabel = ({
  primaryText,
  secondaryText,
  tertiaryText,
  labelClasses,
  labelElementType,
  labelProps,
  secondaryTextId,
  tertiaryTextId,
}: QuestionLabelProps) => {
  const secondaryTextComponent =
    !!secondaryText &&
    (typeof secondaryText === "string" ? (
      <TextOrHTML
        id={secondaryTextId}
        className="mobius-question__secondary-text"
        text={secondaryText}
        textWrapper
      />
    ) : (
      secondaryText
    ));

  const tertiaryTextComponent = !!tertiaryText && (
    <TextOrHTML
      id={tertiaryTextId}
      className="mobius-question__tertiary-text"
      text={tertiaryText}
      textWrapper
    />
  );

  return (
    <>
      <Label
        className={labelClasses}
        elementType={labelElementType}
        {...labelProps}
      >
        <TextOrHTML text={primaryText} />
      </Label>
      {secondaryTextComponent}
      {tertiaryTextComponent}
    </>
  );
};
